/* Dr. Vonda Wright — Custom JS (~2.5KB)
   Scroll fade-in, animated counters, expandable cards
   All IntersectionObserver-based, respects prefers-reduced-motion */

(function() {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* === Scroll Fade-In === */
  if (!reduced) {
    var fadeObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vonda-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.1 });

    function initFade() {
      document.querySelectorAll('.vonda-fade-in').forEach(function(el) {
        fadeObserver.observe(el);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFade);
    } else {
      initFade();
    }
    document.addEventListener('shopify:section:load', function(e) {
      e.target.querySelectorAll('.vonda-fade-in').forEach(function(el) {
        fadeObserver.observe(el);
      });
    });
  }

  /* === Animated Counter === */
  if (!reduced) {
    var counterObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.dataset.counterTarget.replace(/,/g, ''), 10);
        var suffix = el.dataset.counterSuffix || '';
        var prefix = el.dataset.counterPrefix || '';
        var duration = 1800;
        var startTime = performance.now();

        function update(now) {
          var elapsed = now - startTime;
          var progress = Math.min(elapsed / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(eased * target);
          el.textContent = prefix + current.toLocaleString() + suffix;
          if (progress < 1) requestAnimationFrame(update);
        }
        requestAnimationFrame(update);
        counterObserver.unobserve(el);
      });
    }, { threshold: 0.5 });

    function initCounter() {
      document.querySelectorAll('[data-counter-target]').forEach(function(el) {
        counterObserver.observe(el);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCounter);
    } else {
      initCounter();
    }
    document.addEventListener('shopify:section:load', function(e) {
      e.target.querySelectorAll('[data-counter-target]').forEach(function(el) {
        counterObserver.observe(el);
      });
    });
  }

  /* === Expandable Cards === */
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-expand-toggle]');
    if (!toggle) return;
    var card = toggle.closest('[data-expand-card]');
    if (!card) return;
    var content = card.querySelector('[data-expand-content]');
    if (!content) return;
    var isOpen = card.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', String(isOpen));
    content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : '0';
  });

  /* === Video Embed (lazy iframe on click) === */
  document.addEventListener('click', function(e) {
    var play = e.target.closest('.vonda-video-embed__play');
    if (!play) return;
    var container = play.closest('.vonda-video-embed');
    if (!container) return;
    var url = container.dataset.videoUrl;
    if (!url) return;
    var iframe = document.createElement('iframe');
    iframe.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;
    container.innerHTML = '';
    container.appendChild(iframe);
  });
})();
